/**
 *
 *
 *
 *
 *
 *
 */
import { useSyncExporter } from "../common/useSyncExporter.js";
import { coreAsync, coreSync, type CoreSync } from "../globals/core.js";

export type { Serializable } from "../lib/core/head.js";
export type { CoreRaw } from "../lib/core/index";

export * from "../common/useAsyncExporter.js";
export * from "../lib/core/async/promise.js";
export * from "../lib/core/async/promise.types.js";

/*                                       */
const asExport = useSyncExporter(({ o_util }) => o_util.core);

export {
  /*                                                                   */
  coreSync as core,
  /*                                                                      */
  coreAsync,
};

/**
 *
 *
 *
 */
export const isEmptyObject: CoreSync["isEmptyObject"] = asExport("isEmptyObject");

/**
 *
 *
 *
 */
export const isPlainObject: CoreSync["isPlainObject"] = asExport("isPlainObject");

/**
 *
 *
 *
 */
export const withMacrotask: CoreSync["withMacrotask"] = asExport("withMacrotask");

/**
 *
 *
 *
 *
 */
export const withRenderSlice: CoreSync["withRenderSlice"] = asExport("withRenderSlice");

/**
 *
 *
 *
 *
 */
export const withPromise: CoreSync["withPromise"] = asExport("withPromise");
